import { gql } from '@apollo/client';

export const TestFragment = gql`
    fragment Test on OLTest {
        id
        userId
        subjectId
        courseId
        questionIds
        maxScore
        usualScore
        resultScore
        resultOriginScore
        maxOriginScore
        finalAssessmentScore
        resultSuccess
        startedAt
        endTime
        leftTime
        finished
        finishedAt
        answers {
            questionId
            answerIds
        }
    }
`;
